import store from '@/store';
import sensors from '@/utils/sensors';
import utils, { permissionRequired } from '@/utils/utils';

const customDirectives = {
  install(Vue, options) {
    Vue.directive('has', {
      inserted: (el, binding, vnode) => {
        filterGlobalPermission(el, binding, vnode);
      }
    });
    Vue.directive('dis', {
      inserted: (el, binding, vnode) => {
        filterGlobalPermissionDisable(el, binding, vnode);
      }
    });
    Vue.directive('tc', {
      inserted: (el, binding, vnode) => {
        const url = window.location.href;
        const title = document.title;

        el.addEventListener('click', () => {
          // 记录点击事件埋点
          const params = {
            $url: url,
            $title: title,
            name: binding.value.name
          };
          if (binding.value.label) {
            params.label = binding.value.label;
          }
          utils.trackClick(params);
        });
      }
    });
  }
};
/**
 * 全局权限控制
 */

// 隐藏
export const filterGlobalPermission = (el, binding, vnode) => {
  if (!permissionRequired(binding.value.code, binding.value.project, store.state.permissions)) {
    el.parentNode.removeChild(el);
  }
};

// 禁用
export const filterGlobalPermissionDisable = (el, binding, vnode) => {
  if (!permissionRequired(binding.value.code, binding.value.project, store.state.permissions)) {
    el.setAttribute('disabled', true);
  }
};

export default customDirectives;
